import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild, ViewChildren} from '@angular/core';
import {BaseComponent} from '../../../../../../shared/components/base/base.component';
import {Subject, Subscription} from 'rxjs';
import {NgForm} from '@angular/forms';
import {MatSelect, MatOption} from '@angular/material';
import {DocumentTypeService} from '../../../../../../core/services/document-type.service';
import {UserService} from '../../../../../../core/services/user.service';
import {DocumentService} from '../../../../../../core/services/document.service';
import {MatDialog} from '@angular/material/dialog';
import {NotificationService} from '../../../../../../core/services/notification.service';
import {CommonService} from '../../../../../../core/services/common.service';
import {Message} from '../../../../../../core/class/message';
import {SCREEN_SIZE} from 'src/app/core/constants/screen-size';
import {ReportService} from '../../../../../../core/services/report.service';
import {EnumContractEnterpriseStatus, EnumContractStatus} from 'src/app/core/constants/contract';
import FileUtils from '../../../../../../core/services/file-utils';
import {Ng4LoadingSpinnerService} from 'ng4-loading-spinner';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';
import * as _ from 'lodash';
import moment from 'moment';
@Component({
  selector: 'app-contract-enterprise-receive',
  templateUrl: './contract-enterprise-receive.component.html',
  styleUrls: ['./contract-enterprise-receive.component.scss']
})
export class ContractEnterpriseReceiveComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
  /**
   * Check status of document for process update
   */
  checkUpdateDocument = false;
  public warningContractQuantity = false;
  public mediaBreakpoint: any;
  public SCREEN_SIZE = SCREEN_SIZE;
  mode = 3;
  subscription: Subscription;
  enterpriseId;
  checkFocus = true;
  receiveDateErr = '';
  expiredDateErr = '';
  @ViewChild('myForm', {static: false}) ngForm: NgForm;
  @ViewChild('groupForm', {static: false}) groupForm: NgForm;

  @ViewChild('timePeriod', {static: false}) timePeriod: MatSelect;
  @ViewChildren('focusInput') focusInput;
  @ViewChild('allSelectedProcess', {static: false}) allSelectedProcess: MatOption;
  @ViewChild('contractEnterpriseStatusSelect', {static: false}) contractEnterpriseStatusSelect: MatSelect;
  @ViewChild('allSelectedStatus', {static: false}) allSelectedStatus: MatOption;
  @ViewChild('statusSelect', {static: false}) statusSelect: MatSelect;
  
  documents = new Documents();
  exportForm = new Documents();
  EnumContractStatus = EnumContractStatus;
  EnumContractEnterpriseStatus = EnumContractEnterpriseStatus;

  sortName = '';
  sortType = '';

  // tslint:disable-next-line:variable-name
  private _onDestroy = new Subject<void>();
  showSpinner = false;

  isNotAttestedUser: boolean = false;

  constructor(
    private documentTypeService: DocumentTypeService,
    private usService: UserService,
    private documentService: DocumentService,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    public commonService: CommonService,
    public message: Message,
    private reportService: ReportService,
    private spinnerService: Ng4LoadingSpinnerService,
    private toastr: ToastrService,
    private translateService: TranslateService
  ) {
    super(commonService, message);
    this.isNotAttestedUser = this.commonService.checkEnterpriseType();
  }

  ngOnInit() {
    this.enterpriseId = localStorage.getItem('enterpriseId');
    this.notificationService.subscribeErrorService();
    window.scrollTo(0, 0);

  }

  ngAfterViewInit(page: number = 0) {
    // setTimeout(_ => this.focusInput.first.nativeElement.focus());
  }

  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
  }

  /**
   * Get data when init
   */
  loadData() {
  }

  onExportReport() {
    console.log('send info excel', this.documents);
    if(this.sortName && this.sortType) {
      this.documents.sorts = {[this.sortName]: this.sortType};
    } else {
      this.documents.sorts = {}
    }
    this.exportForm = _.cloneDeep(this.documents)
    // this.showSpinner = true;
    // this.spinnerService.show();
    // this.reportService.exportContractEnterpriseReceiveQuantity(this.documents).subscribe(rs => {
    //   if (rs && rs.size > 0) {
    //     this.toastr.success(this.translateService.instant('toastr_report.download_success'));
    //     FileUtils.downLoadFile(rs, 'application/octet-stream', 'Bao_cao_hop_dong_cong_ty_nhan.xls');
    //   } else {
    //     this.toastr.warning(this.translateService.instant('toastr_report.no_content'));
    //   }
    //   this.showSpinner = false;
    //   this.spinnerService.hide();
    // }, err => {
    //   this.spinnerService.hide();
    //   this.toastr.error(this.translateService.instant('toastr_report.download_error'));
    // });
  }

  clickOptionContractEnterpriseStatusAll() {
    // if (this.documents.contractEnterpriseStatus.length > 1) {
    //   this.documents.contractEnterpriseStatus = [-1];
    // }

    if(this.allSelectedProcess.selected){
      this.contractEnterpriseStatusSelect.options.filter(x => x.value !== undefined && x.value !== -1).forEach((item: MatOption) => {
        item.select();
      });
    } else {
      this.contractEnterpriseStatusSelect.options.filter(x => x.value !== undefined && x.value !== -1).forEach((item: MatOption) => {
        item.deselect();
      });
    }
  }

  clickOptionContractEnterpriseStatus() {
    // if (this.documents.contractEnterpriseStatus[0] === -1 && this.documents.contractEnterpriseStatus.length > 1) {
    //   this.documents.contractEnterpriseStatus = this.documents.contractEnterpriseStatus.filter(id => id !== -1);
    // }

    if(this.allSelectedProcess.selected) {
      this.allSelectedProcess.deselect();
    }
    if(this.contractEnterpriseStatusSelect.options.length - 1 == this.documents.contractEnterpriseStatus.length) {
      this.allSelectedProcess.select();
    }
  }

  clickOptionStatusAll() {
    console.log("this.documents.status: ", this.documents.status);
    // if (this.documents.status.length > 1) {
    //   this.documents.status = [-1];
    // }
    if(this.allSelectedStatus.selected){
      this.statusSelect.options.filter(x => x.value !== undefined && x.value !== -1).forEach((item: MatOption) => {
        item.select();
      });
    } else {
      this.statusSelect.options.filter(x => x.value !== undefined && x.value !== -1).forEach((item: MatOption) => {
        item.deselect();
      });
    }
  }

  clickOptionStatus() {
    // if (this.documents.status[0] === -1 && this.documents.status.length > 1) {
    //   this.documents.status = this.documents.status.filter(id => id !== -1);
    // }

    if(this.allSelectedStatus.selected) {
      this.allSelectedStatus.deselect();
    }
    if(this.statusSelect.options.length - 1 == this.documents.status.length) {
      this.allSelectedStatus.select();
    }
  }

  onChangeSortSelection() {
    if (this.sortName === 'expiredDate' || this.sortName === 'receiveTime') {
      this.sortType = 'DESC';
    } else if (this.sortName === 'contractCode' || this.sortName === 'contractName') {
      this.sortType = 'ASC';
    } else {
      this.sortType = '';
    }
  }

  filterForm(filterForm){
    if(!filterForm.contractEnterpriseReceiveSearchFilter){
      window.scrollTo(0, 0);
      return;
    }
    this.documents = new Documents;
    const data = filterForm.contractEnterpriseReceiveSearchFilter
    if (data.receiveFromDate)
      data.receiveFromDate = moment(data.receiveFromDate).format('YYYY-MM-DD')
    if (data.receiveToDate)
      data.receiveToDate = moment(data.receiveToDate).format('YYYY-MM-DD')
    if (data.expiredFromDate)
      data.expiredFromDate = moment(data.expiredFromDate).format('YYYY-MM-DD')
    if (data.expiredToDate)
      data.expiredToDate = moment(data.expiredToDate).format('YYYY-MM-DD')
    if (data.sorts) {
      if (data.sorts.expiredDate) {
        this.sortName = 'expiredDate';
        this.sortType = data.sorts.expiredDate
      } else
        if (data.sorts.createdTime) {
          this.sortName = 'createdTime';
          this.sortType = data.sorts.createdTime
        } else
          if (data.sorts.contractCode) {
            this.sortName = 'contractCode';
            this.sortType = data.sorts.contractCode
          } else
            if (data.sorts.contractName) {
              this.sortName = 'contractName';
              this.sortType = data.sorts.contractName
            } else {
              this.sortName = null
            }
    }
    this.documents = filterForm.contractEnterpriseReceiveSearchFilter;
    window.scrollTo(0, 0);
  }

  unSelectSort() {
    this.sortName = null;
    this.sortType = null;
  }
}

export class Documents {
  createEnterpriseName: any;
  signEnterpriseNameEmail: any;
  contractEnterpriseStatus: any = [];
  status: any = [];
  receiveFromDate: any;
  receiveToDate: any;
  expiredFromDate: any;
  expiredToDate: any;
  contractCode: any;
  contractName: any;
  groupBy: any;
  sorts: any;
}
